module.exports = __webpack_public_path__ + "static/media/icon_circle.c15a4cf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_circle.png
// module id = 1769
// module chunks = 0 1